import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./QuoteActions.module.css";
import { Trash2, MoreVertical } from "react-feather";
import AppContext from "../../store/app-context";

export default function QuoteActions({ status, quoteId, onDeleteSuccess, onDeleteError }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const appCtx = useContext(AppContext);

  let submit_review = 'Submit for review';
  let req_support = 'Request support';
  let label_delete = 'Delete';
  let create_order = 'Create order';
  let req_renewal = 'Request renewal';

  if(appCtx && appCtx.bioradResources){
    submit_review = appCtx.bioradResources.SubmitReview ? appCtx.bioradResources.SubmitReview : 'Submit for review';
    req_support = appCtx.bioradResources.ReqSupport ? appCtx.bioradResources.ReqSupport : 'Request support';
    label_delete = appCtx.bioradResources.Delete ? appCtx.bioradResources.Delete : 'Delete'; 
    create_order = appCtx.bioradResources.CreateOrder ? appCtx.bioradResources.CreateOrder : 'Create order'; 
    req_renewal = appCtx.bioradResources.ReqRenewal ? appCtx.bioradResources.ReqRenewal : 'Request renewal'; 
  }
  useEffect(() => {
    const handleClickOutside = e => {
      if (open && menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const quoteDetailLink = status === 'Not Submitted' ? '/'+quoteId : '/quotes/'+quoteId;
  
  const goToCart     = () => navigate(`/${quoteId}`);
  const goToHelp     = () => window.location.href = appCtx?.envProp?.webServer + "help-center/quote-inquiries";
  const goToDetails  = () => navigate(quoteDetailLink);
  const deleteQuote  = async() => {
    const deleteItemServiceURL = '/quoteservices/rfqs/item/'+ quoteId + '/all';
    try{
      const response = await fetch(deleteItemServiceURL, { method: 'delete', headers: {'Content-type': 'application/text'}} );
      const data = await response.json();
      if (!response.ok || data?.status === 'fail') {
        if (onDeleteError) 
          onDeleteError(data?.message || "Delete failed.");
      } else {
        if (onDeleteSuccess) onDeleteSuccess(data);
      }
    } catch (error) {
      if (onDeleteError) 
        onDeleteError("Unexpected error occurred.");
    } finally {
      setOpen(false);
    }
  };

  const items = [];
  const key = (status || "").toLowerCase().replace(/\s/g, "");

  switch (key) {
    case "draft":
    case "notsubmitted":
      items.push({ label: submit_review, onClick: goToCart });
      items.push({ label: req_support, onClick: goToHelp });
      items.push({ label: label_delete,onClick: deleteQuote, danger: true });
      break;

    case "ready":
      items.push({ label: create_order,    onClick: goToCart });
      break;

    case "expired":
      items.push({ label: req_renewal, onClick: goToDetails });
      break;   
    default:
      break; 
  }
  
  if (!items.some(item => item.label === req_support)) {
    items.push({ label: req_support, onClick: goToHelp });
  }

  return (
    <div className={styles.wrapper} ref={menuRef}>
      <button
        className={styles.actionBtn}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        <MoreVertical width="16" height="16"/>
      </button>

      {open && (
        <ul className={styles.menu} role="menu">
          {items.map(({ label, onClick, danger }) => (
            <li className={styles.menuItems} key={label}>
              <button
                className={`${styles.menuItem} ${danger ? styles.danger : ""}`}
                onClick={onClick}
                role="menuitem"
              >
                {danger && (<Trash2 width="16" height="16"/>)}{label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}